"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformDenyAllPlugin = void 0;
const transform = (ctx) => {
    var _a, _b;
    try {
        const integrations = (_b = (_a = ctx.event) === null || _a === void 0 ? void 0 : _a.integrations) !== null && _b !== void 0 ? _b : {};
        delete integrations.All;
        for (let key in integrations) {
            const isBooleanAndTrue = typeof integrations[key] === 'boolean' && integrations[key] === true;
            const isObject = typeof integrations[key] === 'object';
            const isNeitherTrueNorObject = !(isBooleanAndTrue || isObject);
            if (isNeitherTrueNorObject)
                integrations[key] = false;
        }
        ctx.updateEvent('integrations', integrations);
    }
    catch (e) {
        console.log(e);
    }
    return ctx;
};
exports.transformDenyAllPlugin = {
    name: 'Transform Deny All',
    type: 'enrichment',
    version: '1.0.0',
    isLoaded: () => true,
    load: () => Promise.resolve(),
    track: transform,
    page: transform,
    identify: transform,
};
//# sourceMappingURL=transformDenyAll.js.map